module.exports = __webpack_public_path__ + "img/panelView_defaultBg_strong_2_1.3db4ce30.png";